/* 
  일자    : 2020.03.05
  작성자  : 윤태진
  내용    : 라우터를 통한 컴포넌트 이동 전 권한/토큰 등.. 체크 모듈 작성
  로그인 토큰 정보 : accessToken / refreshToken / Authorization
*/
import axios from "axios";

/* accessToken 체크 모듈 */
async function isMgr() {
  let isManager = false;
  await axios
    .post("/api/org/checkSmgr")
    .then(res => {
        if (res.data.result === true) {
            isManager = true;
        }
    })
    .catch(function(err) {
      console.log(err);
    });
  return isManager;
}
export default isMgr;



// WEBPACK FOOTER //
// ./src/router/isMgrModule.js